export const textEn = {
  yearly: [
    {
      name: "Yearly",
      url:"https://otmtrading.lemonsqueezy.com/buy/b5f7e18b-7f81-4d8e-bc48-7d03cb5e6e29",
      price: 390,
      price2: "499",
      pricesub: "per year",
      button: "Buy",
      features: [
        { text: "OTM Algorithms", icon: "✓" },
        { text: "OTM Swing", icon: "✓" },
        { text: "OTM Micro", icon: "✓" },
        { text: "OTM VWAP", icon: "✓" },
        { text: "OTM Profile", icon: "✓" },
        { text: "OTM Delta Bar", icon: "✓" },
        { text: "OTM Cumulative Delta", icon: "✓" },
        { text: "OTM Bar Timmer", icon: "✓" },
      ],
      color1: "#2db0ff",
      color2: "#6c63ff",      
    },
    {
      name: "Lifetime",
      url:"https://otmtrading.lemonsqueezy.com/buy/761fe931-9e04-4f84-92f9-3c983923694c",
      urlpayments:"https://otmtrading.lemonsqueezy.com/buy/d9862b3d-a091-4f86-811d-a37a1859a3c9",
      price: 790,
      price2: "899",
      pricesub: "one time payment",
      button: "Buy",
      features: [
        { text: "OTM Algorithms", icon: "✓" },
        { text: "OTM Swing", icon: "✓" },
        { text: "OTM Micro", icon: "✓" },
        { text: "OTM VWAP", icon: "✓" },
        { text: "OTM Profile", icon: "✓" },
        { text: "OTM Delta Bar", icon: "✓" },
        { text: "OTM Cumulative Delta", icon: "✓" },
        { text: "OTM Bar Timmer", icon: "✓" },
      ],
      color1: "#BF08E3",
      color2: "#FF4ED6",
      paymentstext:"Defer payments",
      payments: "5 payments of $158",
      
    },
  ],
  lifetime: [
    {
      name: "Yearly",
      url:"https://otmtrading.lemonsqueezy.com/buy/b5f7e18b-7f81-4d8e-bc48-7d03cb5e6e29",
      price: 390,
      price2: "499",
      pricesub: "per year",
      button: "Buy",
      features: [
        { text: "OTM Algorithms", icon: "✓" },
        { text: "OTM Swing", icon: "✓" },
        { text: "OTM Micro", icon: "✓" },
        { text: "OTM VWAP", icon: "✓" },
        { text: "OTM Profile", icon: "✓" },
        { text: "OTM Delta Bar", icon: "✓" },
        { text: "OTM Cumulative Delta", icon: "✓" },
        { text: "OTM Bar Timmer", icon: "✓" },
      ],
      color1: "#2db0ff",
      color2: "#6c63ff",      
    },
    {
      name: "Lifetime",
      url:"https://otmtrading.lemonsqueezy.com/buy/761fe931-9e04-4f84-92f9-3c983923694c",
      urlpayments:"https://otmtrading.lemonsqueezy.com/buy/d9862b3d-a091-4f86-811d-a37a1859a3c9",
      price: 790,
      price2: "899",
      pricesub: "one time payment",
      button: "Buy",
      features: [
        { text: "OTM Algorithms", icon: "✓" },
        { text: "OTM Swing", icon: "✓" },
        { text: "OTM Micro", icon: "✓" },
        { text: "OTM VWAP", icon: "✓" },
        { text: "OTM Profile", icon: "✓" },
        { text: "OTM Delta Bar", icon: "✓" },
        { text: "OTM Cumulative Delta", icon: "✓" },
        { text: "OTM Bar Timmer", icon: "✓" },
      ],
      color1: "#BF08E3",
      color2: "#FF4ED6",
      paymentstext:"Defer payments",
      payments: "5 payments of $158",
      
    },
  ],
};

export const textEs = {
  yearly: [
    {
      name: "Básico",
      price: 390,
      price2: "499",
      url:"https://otmtrading.lemonsqueezy.com/buy/5bb2d4c4-7fa7-4ede-bb71-6ac369fa3d1d",
      pricetext: "/por mes",
      pricesub: "Por año",
      button: "Comprar",
      features: [
        { text: "OTM Algorithms", icon: "✓" },
        { text: "OTM Swing", icon: "✓" },
        { text: "OTM Micro", icon: "✓" },
        { text: "OTM VWAP", icon: "✓" },
        { text: "OTM Profile", icon: "✓" },
        { text: "OTM Delta Bar", icon: "✓" },
        { text: "OTM Cumulative Delta", icon: "✓" },
        { text: "OTM Bar Timmer", icon: "✓" },
      ],
      color1: "#2E94FE",
      color2: "#3ED7FF",
    },
    {
      name: "Plus",
      price: 490,
      price2: "599",
      url:"https://otmtrading.lemonsqueezy.com/buy/34fba67b-8327-427e-83e1-96c9fcbb4a31",
      pricetext: "/por año",
      pricesub: "Por año",
      button: "Comprar",
      features: [
        { text: "OTM Algorithms", icon: "✓" },
        { text: "OTM Swing", icon: "✓" },
        { text: "OTM Micro", icon: "✓" },
        { text: "OTM VWAP", icon: "✓" },
        { text: "OTM Profile", icon: "✓" },
        { text: "OTM Delta Bar", icon: "✓" },
        { text: "OTM Cumulative Delta", icon: "✓" },
        { text: "OTM Bar Timmer", icon: "✓" },
        { text: "Estrategia de continuaciones: Aplicación práctica en video.", icon: "✓" },
        { text: "Estrategia de continuaciones: Video curso.", icon: "✓" },

      ],
      color1: "#BF08E3",
      color2: "#FF4ED6",
    },
  ],
  lifetime: [
    {
      name: "Básico",
      price: 790,
      price2: "899",
      url:"https://otmtrading.lemonsqueezy.com/buy/64b93029-8ffa-4a4b-b483-bbb18ffdc852",
      urlpayments:"https://otmtrading.lemonsqueezy.com/buy/1fa5aef4-db58-4a12-907a-93f1ebfe7f1b",
      pricesub: "Pago único",
      button: "Comprar",
      features: [
        { text: "OTM Algorithms", icon: "✓" },
        { text: "OTM Swing", icon: "✓" },
        { text: "OTM Micro", icon: "✓" },
        { text: "OTM VWAP", icon: "✓" },
        { text: "OTM Profile", icon: "✓" },
        { text: "OTM Delta Bar", icon: "✓" },
        { text: "OTM Cumulative Delta", icon: "✓" },
        { text: "OTM Bar Timmer", icon: "✓" },
      ],
      color1: "#2E94FE",
      color2: "#3ED7FF",
      paymentstext:"Diferir cuotas",
      payments: "5 pagos de $158",
    },
    {
      name: "Plus",
      price: 890,
      price2: "999",
      url:"https://otmtrading.lemonsqueezy.com/buy/947dcb18-835f-4abe-b36d-5a781734e813",
      urlpayments:"https://otmtrading.lemonsqueezy.com/buy/6c8a875d-8fc7-46c5-b412-7b7cabd3d1af",
      pricesub: "Pago único",
      button: "Comprar",
      features: [
        { text: "OTM Algorithms", icon: "✓" },
        { text: "OTM Swing", icon: "✓" },
        { text: "OTM Micro", icon: "✓" },
        { text: "OTM VWAP", icon: "✓" },
        { text: "OTM Profile", icon: "✓" },
        { text: "OTM Delta Bar", icon: "✓" },
        { text: "OTM Cumulative Delta", icon: "✓" },
        { text: "OTM Bar Timmer", icon: "✓" },
        { text: "Estrategia de continuaciones Aplicación práctica en video.", icon: "✓" },
        { text: "Estrategia de continuaciones Video curso.", icon: "✓" },
      ],
      color1: "#BF08E3",
      color2: "#FF4ED6",
      paymentstext:"Diferir cuotas",
      payments: "5 pagos de $178",
    },
  ],
};
